import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Sets default value of observable, if observable value is null (or an empty string if `evaluateEmptyString` param is true)
 * @param defaultValue Value to be set when evaluated as null or empty
 * @param evaluateEmptyString When true and value is an empty string, the value will be replaced with the default value
 * @returns Observable<T>
 */
export function withDefault<T>(defaultValue: T, evaluateEmptyString: boolean = false) {
  return (observable: Observable<T | null | undefined>) =>
    observable.pipe(
      map((r) =>
        r == null || (evaluateEmptyString && typeof r === 'string' && r === '') ? defaultValue : r,
      ),
    );
}
